(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cosmic-closet"] && !Shopify.designMode) return;
  try {
    
  let cosmicAssetLoading = false;
  function loadCosmicCloset() {
    if (cosmicAssetLoading || customElements.get('cosmic-closet-game')) return;
    const game = document.querySelector('cosmic-closet-game[data-game-script]');
    if (!game) return;
    cosmicAssetLoading = true;
    const script = document.createElement('script');
    script.src = game.dataset.gameScript;
    script.defer = true;
    script.onerror = () => {
      cosmicAssetLoading = false;
      game.textContent = 'The arcade could not load. Please refresh to try again.';
      script.remove();
    };
    document.head.append(script);
  }
  loadCosmicCloset();
  document.addEventListener('shopify:section:load', loadCosmicCloset);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
